import React from 'react';
import { string, bool } from 'prop-types';
import { BrowserRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { SiteFooter } from '@tesla/tw-react';
import { ContentContainer, Loader } from '@tesla/design-system-react';

import Content from './pages';
import Selectors from './selectors';
import * as Actions from './actions';

import '@tesla/design-system/dist/index.css';
import './css/reset.css';
import '@tesla/tw-react/dist/index.css';

import styles from './App.module.css';

const propTypes = {
  baseRoute: string.isRequired,
  locale: string.isRequired,
  showLoader: bool.isRequired,
};

const App = ({ baseRoute, locale, showLoader }) => {
  return (
    <>
      <div className={styles.AppWrapper}>
        <BrowserRouter basename={baseRoute}>
          <Loader fullscreen show={showLoader} />
          <ContentContainer size="small">
            <div id="main-content">
              <Content />
            </div>
          </ContentContainer>
        </BrowserRouter>
      </div>
      <SiteFooter locale={locale} />
    </>
  );
};
App.propTypes = propTypes;

export default connect(
  Selectors,
  Actions
)(App);
